module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "55%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "55%",
				"height": "45%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.15384615384616,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#043f61"
					},
					{
						"y": 96.15384615384616,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0c4250"
					},
					{
						"y": 96.15384615384616,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#09472e"
					},
					{
						"y": 42.30769230769231,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.7741935483871,
						"dataLabels": {
							"enabled": false,
							"format": "60"
						},
						"color": "#043f61"
					},
					{
						"y": 88.70967741935483,
						"dataLabels": {
							"enabled": false,
							"format": "55"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.48387096774194,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.41935483870968,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#09472e"
					},
					{
						"y": 43.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.7741935483871,
						"dataLabels": {
							"enabled": false,
							"format": "60"
						},
						"color": "#043f61"
					},
					{
						"y": 96.7741935483871,
						"dataLabels": {
							"enabled": false,
							"format": "60"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.32258064516128,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#09472e"
					},
					{
						"y": 64.51612903225806,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.63898916967509,
						"dataLabels": {
							"enabled": false,
							"format": "276"
						},
						"color": "#043f61"
					},
					{
						"y": 99.63898916967509,
						"dataLabels": {
							"enabled": false,
							"format": "276"
						},
						"color": "#0c4250"
					},
					{
						"y": 99.63898916967509,
						"dataLabels": {
							"enabled": false,
							"format": "276"
						},
						"color": "#0d4440"
					},
					{
						"y": 94.94584837545126,
						"dataLabels": {
							"enabled": false,
							"format": "263"
						},
						"color": "#09472e"
					},
					{
						"y": 70.7581227436823,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#09472e"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#043f61"
					},
					{
						"y": 92.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#09472e"
					},
					{
						"y": 40.74074074074074,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#0c4250"
					},
					{
						"y": 98.59154929577466,
						"dataLabels": {
							"enabled": false,
							"format": "70"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.09859154929578,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#09472e"
					},
					{
						"y": 43.66197183098591,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "211"
						},
						"color": "#043f61"
					},
					{
						"y": 99.52606635071089,
						"dataLabels": {
							"enabled": false,
							"format": "210"
						},
						"color": "#0c4250"
					},
					{
						"y": 95.260663507109,
						"dataLabels": {
							"enabled": false,
							"format": "201"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.62559241706161,
						"dataLabels": {
							"enabled": false,
							"format": "187"
						},
						"color": "#09472e"
					},
					{
						"y": 60.66350710900474,
						"dataLabels": {
							"enabled": false,
							"format": "128"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#043f61"
					},
					{
						"y": 43.75,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 31.25,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 18.75,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#043f61"
					},
					{
						"y": 82.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0c4250"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.85714285714286,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#09472e"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.15384615384616,
						"dataLabels": {
							"enabled": false,
							"format": "50"
						},
						"color": "#043f61"
					},
					{
						"y": 88.46153846153845,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.53846153846155,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#09472e"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.83794466403161,
						"dataLabels": {
							"enabled": false,
							"format": "245"
						},
						"color": "#043f61"
					},
					{
						"y": 92.09486166007905,
						"dataLabels": {
							"enabled": false,
							"format": "233"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.51383399209486,
						"dataLabels": {
							"enabled": false,
							"format": "229"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.95652173913044,
						"dataLabels": {
							"enabled": false,
							"format": "220"
						},
						"color": "#09472e"
					},
					{
						"y": 64.42687747035573,
						"dataLabels": {
							"enabled": false,
							"format": "163"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.99999999999999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2258064516129004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.6363636363636376,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.433962264150942,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -43.75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2258064516129004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.3610108303249149,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.710144927536231,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.47528517110266,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.4074074074074066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.888888888888886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.4084507042253502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.714285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -47.45762711864406,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.4739336492891044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.285714285714281,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.965174129353235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.550802139037437,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.043478260869568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.8421052631579,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.1739130434782594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.2222222222222254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.72727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1620553359683834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.897959183673473,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.716738197424894,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9301310043668103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.909090909090903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=26"
			},
			{
				"x": 9,
				"text": "30-39<br>n=62"
			},
			{
				"x": 15,
				"text": "40-49<br>n=62"
			},
			{
				"x": 21,
				"text": ">=50<br>n=277"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=7"
			},
			{
				"x": 34,
				"text": "30-39<br>n=27"
			},
			{
				"x": 40,
				"text": "40-49<br>n=71"
			},
			{
				"x": 46,
				"text": ">=50<br>n=211"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=16"
			},
			{
				"x": 59,
				"text": "30-39<br>n=28"
			},
			{
				"x": 65,
				"text": "40-49<br>n=52"
			},
			{
				"x": 71,
				"text": ">=50<br>n=253"
			}
		],
		"dataTable": {
			"MSM:<30": [
				26,
				25,
				25,
				25,
				20,
				11
			],
			"MSM:30-39": [
				62,
				60,
				55,
				53,
				48,
				27
			],
			"MSM:40-49": [
				62,
				60,
				60,
				58,
				56,
				40
			],
			"MSM:>=50": [
				277,
				276,
				276,
				276,
				263,
				196
			],
			"Non-MSM:<30": [
				7,
				7,
				6,
				6,
				6,
				3
			],
			"Non-MSM:30-39": [
				27,
				25,
				25,
				25,
				18,
				11
			],
			"Non-MSM:40-49": [
				71,
				71,
				71,
				70,
				59,
				31
			],
			"Non-MSM:>=50": [
				211,
				211,
				210,
				201,
				187,
				128
			],
			"Unknown:<30": [
				16,
				10,
				7,
				6,
				5,
				3
			],
			"Unknown:30-39": [
				28,
				27,
				23,
				20,
				19,
				12
			],
			"Unknown:40-49": [
				52,
				50,
				46,
				45,
				44,
				34
			],
			"Unknown:>=50": [
				253,
				245,
				233,
				229,
				220,
				163
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_5.json
// module id = 340
// module chunks = 0